import t from "prop-types";
import r, { Component as C, useState as z, useRef as A } from "react";
import c from "classnames";
import { n as w } from "./Normalize.module-BSsVv-vB.es.js";
import { u as B } from "./ThemeProvider--i7ESlT5.es.js";
import { u as M } from "./utils-C0l876fA.es.js";
import { I as P } from "./Icon-ByeAHRM4.es.js";
import { u as W } from "./DarkModeProvider-xoZXm3ct.es.js";
import K from "react-dom";
import './Tooltip.css';const Q = "#519de9", F = "#ccc", H = "#fff", V = "8px", q = "16px", U = "Tooltip-module__tooltip_container___MLHvB", X = "Tooltip-module__darken_container___xxzHg", $ = "Tooltip-module__click_container___l3FBu", Y = "Tooltip-module__trigger___emHj-", Z = "Tooltip-module__force_container___aQWqE", G = "Tooltip-module__tooltip___NMZ65", j = "Tooltip-module__top___RflAS", J = "Tooltip-module__arrow___fL2PX", oo = "Tooltip-module__right___sP0Xp", to = "Tooltip-module__bottom___fQeWI", eo = "Tooltip-module__left___8Pm6o", ro = "Tooltip-module__arrow_light___sxuIx", io = "Tooltip-module__arrow_dark___yTJLu", so = "Tooltip-module__arrow_warning___5ogmi", no = "Tooltip-module__arrow_tour___c4GZS", lo = "Tooltip-module__arrow_tour_compere___QoQ6u", ao = "Tooltip-module__body_light___YPzDP", co = "Tooltip-module__body_dark___Tv4GE", po = "Tooltip-module__body_warning___9ZQWL", _o = "Tooltip-module__body_tour___-Svxc", uo = "Tooltip-module__body_tour_compere___M3hx5", ho = "Tooltip-module__shadow_light___VfvRQ", mo = "Tooltip-module__shadow_heavy___AmQVK", go = "Tooltip-module__exit_button___Qfiek", e = {
  trigger_color: Q,
  icon_color: F,
  icon_color_dark: H,
  short_spacing: V,
  default_spacing: q,
  tooltip_container: U,
  darken_container: X,
  click_container: $,
  trigger: Y,
  force_container: Z,
  tooltip: G,
  top: j,
  arrow: J,
  right: oo,
  bottom: to,
  left: eo,
  arrow_light: ro,
  arrow_dark: io,
  arrow_warning: so,
  arrow_tour: no,
  arrow_tour_compere: lo,
  body_light: ao,
  body_dark: co,
  body_warning: po,
  body_tour: _o,
  body_tour_compere: uo,
  shadow_light: ho,
  shadow_heavy: mo,
  exit_button: go
}, g = ({
  children: i,
  placement: o,
  hideCloseIcon: n,
  onClose: s,
  passOnClose: p,
  xOffsetArrow: _,
  xOffset: a,
  yOffsetArrow: d,
  yOffset: l,
  dark: u,
  tour: h,
  warning: m,
  heavyShadow: b,
  short: O,
  id: D
}) => {
  const E = W(u), S = B(), { t: L } = M();
  let f = e.arrow_light, y = e.body_light;
  m ? (f = e.arrow_warning, y = e.body_warning) : E ? (f = e.arrow_dark, y = e.body_dark) : h && (f = S === "compere" ? e.arrow_tour_compere : e.arrow_tour, y = S === "compere" ? e.body_tour_compere : e.body_tour);
  let x = e.shadow_light;
  b && (x = e.shadow_heavy);
  const N = `translate(${a + _}px, ${l + d}px)`, I = h || E ? e.icon_color_dark : e.icon_color;
  return /* @__PURE__ */ r.createElement(
    "div",
    {
      className: c(e.tooltip, e[o]),
      id: D,
      role: "tooltip"
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        className: c(e.arrow, f),
        style: { transform: N }
      }
    ),
    /* @__PURE__ */ r.createElement(
      "div",
      {
        className: c(y, x),
        style: {
          transform: `translate(${a}px, ${l}px)`,
          padding: O ? e.short_spacing : e.default_spacing
        }
      },
      n ? null : /* @__PURE__ */ r.createElement(
        "button",
        {
          className: e.exit_button,
          onClick: s,
          type: "button",
          "aria-label": L("Close")
        },
        /* @__PURE__ */ r.createElement(P, { name: "close", size: 20, color: I })
      ),
      p ? r.Children.map(
        i,
        (R) => r.cloneElement(R, { close: s })
      ) : i
    )
  );
}, fo = {
  dark: t.bool,
  heavyShadow: t.bool,
  hideCloseIcon: t.bool,
  onClose: t.func,
  passOnClose: t.bool,
  placement: t.oneOf(["top", "right", "bottom", "left"]).isRequired,
  warning: t.bool,
  xOffsetArrow: t.number,
  xOffset: t.number,
  yOffsetArrow: t.number,
  yOffset: t.number,
  tour: t.bool,
  padding: t.number,
  id: t.string,
  short: t.bool,
  children: t.node.isRequired,
  ariaDescribedBy: t.string,
  ariaLabel: t.string
}, yo = {
  dark: void 0,
  heavyShadow: !1,
  hideCloseIcon: !1,
  onClose: () => !1,
  passOnClose: !1,
  warning: !1,
  xOffsetArrow: 0,
  xOffset: 0,
  yOffsetArrow: 0,
  yOffset: 0,
  tour: !1,
  short: !1,
  id: null,
  ariaDescribedBy: void 0,
  ariaLabel: void 0
};
g.propTypes = t.shape(fo).isRequired;
g.defaultProps = yo;
const k = /* @__PURE__ */ r.createElement(P, { name: "info", color: e.trigger_color, size: 16 });
class v extends C {
  constructor(o) {
    super(o), this.onClickOutside = this.onClickOutside.bind(this), this.onKeyDown = this.onKeyDown.bind(this), this.state = {
      open: !1
    };
  }
  UNSAFE_componentWillMount() {
    this.props.show_on_mount && this.setState(() => ({ open: !0 }));
  }
  componentDidMount() {
    document.body.addEventListener("click", this.onClickOutside), document.body.addEventListener("keydown", this.onKeyDown);
  }
  componentWillUnmount() {
    document.body.removeEventListener("click", this.onClickOutside), document.body.removeEventListener("keydown", this.onKeyDown);
  }
  onClickOutside(o) {
    this.tooltip.contains(o.target) || this.close();
  }
  onKeyDown(o) {
    o.code === "Escape" && this.close();
  }
  close() {
    this.state.open && this.props.onClose(), this.setState(() => ({ open: !1 }));
  }
  toggleOpen() {
    this.state.open ? this.props.onClose() : this.props.onOpen(), this.setState((o) => ({ open: !o.open }));
  }
  render() {
    return /* @__PURE__ */ r.createElement(
      "div",
      {
        ref: (o) => {
          this.tooltip = o;
        },
        className: c(
          w.normalize,
          e.tooltip_container,
          e.click_container
        )
      },
      /* @__PURE__ */ r.createElement(
        "div",
        {
          role: "button",
          className: e.trigger,
          onClick: () => {
            this.toggleOpen();
          },
          onKeyDown: (o) => {
            (o.key === "Enter" || o.key === " ") && this.toggleOpen();
          },
          tabIndex: 0,
          "aria-describedby": this.props.ariaDescribedBy,
          "aria-label": this.props.ariaLabel
        },
        this.props.trigger
      ),
      this.state.open ? /* @__PURE__ */ r.createElement(
        g,
        {
          ...this.props,
          onClose: () => {
            this.close();
          }
        }
      ) : null
    );
  }
}
v.propTypes = {
  /** The component that will trigger the tooltip
   * (this will also render this trigger)
   */
  trigger: t.node,
  /* Whether the tooltip should open on mount */
  show_on_mount: t.bool,
  /** Callback when the tooltip is opened */
  onOpen: t.func,
  /** Callback when the tooltip is closed */
  onClose: t.func,
  /** aria-describedby attribute to pass to trigger
   * if accessible prop is true
   */
  ariaDescribedBy: t.string,
  /** aria-label attribute to pass to trigger
   * if accessible prop is true
   */
  ariaLabel: t.string
};
v.defaultProps = {
  trigger: k,
  show_on_mount: !1,
  onOpen() {
  },
  onClose() {
  },
  ariaDescribedBy: void 0,
  ariaLabel: void 0
};
const bo = ({
  trigger: i = k,
  accessible: o = !1,
  closed: n = !1,
  delay: s = 0,
  ariaDescribedBy: p = void 0,
  ariaLabel: _ = void 0,
  ...a
}) => {
  const [d, l] = z(!1), u = A(null), h = () => {
    s ? u.current = setTimeout(() => {
      l(!0);
    }, s) : l(!0);
  }, m = () => {
    s && u.current && clearTimeout(u.current), l(!1);
  };
  return /* @__PURE__ */ r.createElement(
    "div",
    {
      onMouseLeave: m,
      className: c(w.normalize, e.tooltip_container)
    },
    /* @__PURE__ */ r.createElement(
      "div",
      {
        tabIndex: o ? 0 : void 0,
        role: o ? "button" : void 0,
        onFocus: h,
        onBlur: m,
        onMouseEnter: h,
        onKeyDown: (b) => {
          b.key === "Escape" && m();
        },
        "aria-describedby": p,
        "aria-label": _,
        className: e.trigger
      },
      i
    ),
    d && !n ? /* @__PURE__ */ r.createElement(g, { ...a, hideCloseIcon: !0 }) : null
  );
}, wo = (i, o) => i === "top" ? 0 : i === "bottom" ? o : i === "left" || i === "right" ? o / 2 : null, ko = (i, o) => i === "top" || i === "bottom" ? o / 2 : i === "left" ? 0 : i === "right" ? o : null;
class T extends C {
  constructor(o) {
    super(o), this.state = {
      open: !!this.props.open,
      ...this.getPositionStyles()
    }, this.getPositionStyles = this.getPositionStyles.bind(this), this.updatePositionStyles = this.updatePositionStyles.bind(this);
  }
  componentDidMount() {
    window.addEventListener("scroll", this.updatePositionStyles);
  }
  UNSAFE_componentWillReceiveProps(o) {
    this.setState({ open: o.open });
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.updatePositionStyles);
  }
  getPositionStyles() {
    if (this.props.position === "fixed" && this.props.trigger && !r.isValidElement(this.props.trigger)) {
      const { top: o, left: n, height: s, width: p } = this.props.trigger.getBoundingClientRect(), _ = wo(this.props.placement, s), a = ko(this.props.placement, p), d = this.props.sticky ? 0 : window.scrollY, l = this.props.sticky ? 0 : window.scrollX;
      return {
        top: o + d + _,
        left: n + l + a
      };
    }
    return {};
  }
  updatePositionStyles() {
    this.setState(this.getPositionStyles());
  }
  render() {
    const o = { position: this.props.position };
    this.props.display && (o.display = this.props.display), this.props.darken && (o.zIndex = 16385), (this.state.top || this.state.left) && (o.top = this.state.top, o.left = this.state.left);
    const n = /* @__PURE__ */ r.createElement(r.Fragment, null, this.props.darken && this.state.open && /* @__PURE__ */ r.createElement("div", { className: e.darken_container }), /* @__PURE__ */ r.createElement(
      "div",
      {
        ref: (s) => {
          this.tooltip = s;
        },
        className: c(
          w.normalize,
          e.force_container
        ),
        style: o
      },
      r.isValidElement(this.props.trigger) && this.props.trigger,
      this.state.open ? /* @__PURE__ */ r.createElement(g, { ...this.props }) : null
    ));
    return this.props.trigger && !r.isValidElement(this.props.trigger) ? (this.props.darken && (this.props.trigger.style.position = "relative", this.props.trigger.style.zIndex = 16385), K.createPortal(
      n,
      this.props.trigger.parentElement
    )) : n;
  }
}
T.propTypes = {
  /** The component that will trigger the tooltip
   * (this will also render this trigger)
   */
  // eslint-disable-next-line react/forbid-prop-types
  trigger: t.any,
  /** Whether tooltip is open */
  open: t.bool,
  /** CSS display property for trigger */
  display: t.string,
  /** CSS position property for trigger. The default of "relative"
   * aids with positioning in the center of the trigger, but "static"
   * allows the tooltip to render outside of "overflow: hidden" in
   * intermediate ancestors.
   */
  position: t.string,
  /** Whether the close icon should be hidden */
  hideCloseIcon: t.bool,
  /** Whether the tooltip sticks to the same position on the page when you scroll around. */
  sticky: t.bool,
  /** Whether the tooltip puts a dark overlay on the background behind the modal/popup. */
  darken: t.bool,
  /** Placement of the tooltip */
  placement: t.oneOf(["top", "bottom", "left", "right"])
};
T.defaultProps = {
  trigger: k,
  open: !1,
  display: void 0,
  position: "relative",
  hideCloseIcon: !0,
  sticky: !1,
  darken: !1,
  placement: "top"
};
const Lo = {
  Hover: bo,
  Force: T,
  Click: v
};
export {
  fo as S,
  Lo as T
};
